function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  opacity: 0.32,
  cx: 36,
  cy: 36,
  r: 36,
  fill: "#C4C4C4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M37 21C28.168 21 21 28.168 21 37C21 45.832 28.168 53 37 53C45.832 53 53 45.832 53 37C53 28.168 45.832 21 37 21ZM37 25.8C39.656 25.8 41.8 27.944 41.8 30.6C41.8 33.256 39.656 35.4 37 35.4C34.344 35.4 32.2 33.256 32.2 30.6C32.2 27.944 34.344 25.8 37 25.8ZM37 48.52C33 48.52 29.464 46.472 27.4 43.368C27.448 40.184 33.8 38.44 37 38.44C40.184 38.44 46.552 40.184 46.6 43.368C44.536 46.472 41 48.52 37 48.52Z",
  fill: "black",
  fillOpacity: 0.54
});

function SvgUserSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSelected);
export default __webpack_public_path__ + "static/media/user-selected.b468cf9d.svg";
export { ForwardRef as ReactComponent };